import {useScrollEdges} from '#/hooks/use-is-scrolling';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';

export const SnapGridCarousel: FunctionComponent<DefaultChildren> = ({children}) => {
  const {scrollEdges, onScroll} = useScrollEdges();

  if (Array.isArray(children) && children.length === 1) {
    return <>{children}</>;
  }

  return (
    <div className='flex w-full relative'>
      <div
        onScroll={onScroll}
        className={`grid grid-rows-1 auto-cols-[90%] grid-flow-col overflow-x-scroll snap-x snap-mandatory gap-4 ${
          !!scrollEdges ? 'gap-0' : ''
        }`}
      >
        {children}
      </div>

      {(scrollEdges === 'right' || scrollEdges === 'both') && (
        <div className='absolute top-0 left-0 h-full flex pointer-events-none'>
          <div className='h-full w-8 bg-gradient-to-r from-grayblue' />
        </div>
      )}
      {(scrollEdges === 'left' || scrollEdges === 'both') && (
        <div className='absolute top-0 right-0 h-full flex pointer-events-none'>
          <div className='h-full w-8 bg-gradient-to-l from-grayblue' />
        </div>
      )}
    </div>
  );
};
